export const DEFAULT = 'DEFAULT';

export const SHARED_WITH_ME = 'SHARED_WITH_ME';
